import { type SelectProps as ChakraSelectProps, forwardRef, Select as ChakraSelect } from "@chakra-ui/react";
import { injectSelectSize, injectSelectStyle } from "./variant";
import { useMemo, type ForwardedRef } from "react";
import { type SelectSize, type SelectBreakPointSize, type SelectVariant } from "./type";
import { selectTestId } from "./const";
import { scrollOnFocus } from "@/modules/utils/scroll-on-focus";

export interface SelectProps extends Omit<ChakraSelectProps, "size"> {
  readonly size?: SelectSize | SelectBreakPointSize;
  readonly variant?: SelectVariant;
}

export const Select = forwardRef<SelectProps, "select">(
  ({ size = "md", variant = "default", ...rest }: SelectProps, ref: ForwardedRef<HTMLSelectElement>) => {
    const selectSize = useMemo(() => injectSelectSize(size), [size]);
    const selectStyle = useMemo(() => injectSelectStyle(variant), [variant]);

    return (
      <ChakraSelect
        ref={ref}
        onFocus={scrollOnFocus}
        {...selectStyle}
        {...selectSize}
        data-testid={selectTestId}
        {...rest}
      />
    );
  },
);
